import React from "react";
import SearchIcon from "../../assets/images/search.svg";
import down from "../../../src/assets/images/down.svg";
import { ClickAwayListener } from "@mui/material";

// Make the interface more generic to accept any object with optional properties
interface GenericOption {
  [key: string]: any;
}

interface Props {
  value: string;
  onSelect: (newValue: GenericOption) => void;
  label?: string;
  required?: boolean;
  placeholder?: string;
  extraClasses?: string;
  noOptionText?: string;
  renderOption?: any;
  renderValue?: (option: string) => string | React.ReactNode;
  options: GenericOption[];
  searchValue: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>, newValue: string) => void;
  loading?: boolean;
}

const SelectWithBackendSearch = ({
  value,
  onSelect,
  label,
  required = false,
  placeholder,
  extraClasses = "",
  noOptionText = "No Option",
  renderOption,
  renderValue,
  options,
  searchValue,
  onSearchChange,
  loading = false,
}: Props) => {
  const [toggleOpenSelect, setToggleOpenSelect] = React.useState(false);

  return (
    <div className="w-full">
      {label ? (
        <label className="font-medium text-docsigna-blue-dark text-sm block mb-1">
          {label} {required && <span className="text-red-400"> * </span>}
        </label>
      ) : null}
      <div className={`relative rounded  ${extraClasses}`}>
        <button
          type="button"
          onClick={() => setToggleOpenSelect(prev => !prev)}
          className="bg-transparent rounded h-full w-full flex items-center justify-between px-2 font-medium text-docsigna-blue-dark shadow-none border border-docsigna-blue-dark p-2.5 leading-[1.41rem]"
        >
          {(renderValue ? renderValue(value) : value) || placeholder}
          <div className="h-1.5">
            <img src={down} className={`h-1.5`} alt="" />
          </div>
        </button>
        {toggleOpenSelect ? (
          <ClickAwayListener onClickAway={() => setToggleOpenSelect(false)}>
            <div className="absolute z-50 shadow-lg w-full py-2 border rounded-md bg-white m-0 border-docsigna-blue-dark">
              <div className="px-2 mb-2 ">
                <div className="w-full  border border-docsigna-blue-dark h-[35px] rounded flex justify-between items-center pr-2">
                  <input
                    value={searchValue}
                    onChange={e => onSearchChange(e, e.target.value)}
                    className={`border-0 w-full rounded outline-none shadow-none h-full border-none ${searchValue?.length ? "text-black" : ""}`}
                    placeholder="Search"
                  />
                  <img src={SearchIcon} alt="" />
                </div>
              </div>
              {loading ? (
                <div className="text-center text-black-400 py-2">Loading...</div>
              ) : options.length ? (
                <div className="h-48 overflow-auto">
                  {options.map((option, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        onSelect(option);
                        setToggleOpenSelect(false);
                      }}
                      className="cursor-pointer  hover:bg-slate-100  border-slate-400 px-2 py-2"
                    >
                      {renderOption ? renderOption(option) : option.company || option.email || option.fax}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center text-black-400">{noOptionText}</div>
              )}
            </div>
          </ClickAwayListener>
        ) : null}
      </div>
    </div>
  );
};

export default SelectWithBackendSearch;
